<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconFlipCamera_32"
    viewBox="0 0 32 32"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M26 8h-3l-1.447-2.895A2 2 0 0 0 19.764 4h-7.528a2 2 0 0 0-1.79 1.105L9 8H6a4 4 0 0 0-4 4v12a4 4 0 0 0 4 4h20a4 4 0 0 0 4-4V12a4 4 0 0 0-4-4M8.47 21.601l-3.537-3.534a.751.751 0 0 1 .864-1.203l2.204 1.095C8.024 13.567 11.603 10 16 10c1.852 0 3.552.64 4.907 1.704.488.383.477 1.13.002 1.528a.98.98 0 0 1-1.237.028A5.97 5.97 0 0 0 16 12c-3.293 0-5.97 2.668-5.996 5.956l2.197-1.092a.751.751 0 0 1 .864 1.203L9.53 21.6a.75.75 0 0 1-1.06 0m18.674-2.7a.75.75 0 0 1-.943.235l-2.204-1.095C23.976 22.433 20.397 26 16 26a7.9 7.9 0 0 1-4.907-1.704c-.486-.383-.477-1.13-.002-1.528a.98.98 0 0 1 1.237-.028A5.97 5.97 0 0 0 16 24c3.293 0 5.97-2.668 5.996-5.956l-2.197 1.092a.751.751 0 0 1-.864-1.203L22.47 14.4a.75.75 0 0 1 1.061 0l3.535 3.534c.26.26.292.67.077.968"
    />
</svg>
